import { css } from 'lit';
import { visuallyHiddenStyles } from '../../internal/styles/visually-hidden.js';

export default css`
  :host(:not(:focus-within)) {
    ${visuallyHiddenStyles}
  }
`;
